import React from "react";

const CareerHistory = ({ items }) => (
  <section className="new-3d-panel new-3d-career-history-panel">
    <div className="new-3d-career-history-title">Career History</div>
    <div className="new-3d-career-history-divider" />
    <div className="new-3d-career-history-head">
      <div>Role &amp; Company</div>
      <div>Skills</div>
    </div>

    {items.length ? (
      <div className="new-3d-history-list">
        {items.map((item, index) => (
          <article className="new-3d-history-item" key={`${item?.id || item?.title || "role"}-${index}`}>
            <div className="new-3d-career-history-row">
              <div className="new-3d-career-history-left">
                <p className="new-3d-career-history-date">{item?.dateRange || "NA"}</p>
                <h3>{item?.title || "Role title not added"}</h3>
                <p className="new-3d-company-name">{item?.companyName || "Company name not added"}</p>
              </div>

              <div className="new-3d-career-history-right">
                {item?.skills?.length > 0 ? (
                  <div className="new-3d-chip-list new-3d-career-history-chip-list">
                    {item.skills.map((skill, skillIndex) => (
                      <span key={`${skill?.name || "Skill"}-${skillIndex}`}>
                        {skill?.name}
                        {skill?.percent !== undefined && skill?.percent !== null ? ` (${skill.percent}%)` : ""}
                      </span>
                    ))}
                  </div>
                ) : null}

                {item?.summary ? (
                  <p className="new-3d-career-history-description">{item.summary}</p>
                ) : null}
              </div>
            </div>
          </article>
        ))}
      </div>
    ) : (
      <div className="new-3d-empty">No work history added yet</div>
    )}
  </section>
);

export default CareerHistory;
